import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {PesosComponent} from '../pesos.component'
//Services
import {WeightService} from 'src/app/core/services/parameters/weight.service';
//Alert
import {AlertNoticeService} from 'src/app/core/alert/alert.service';

@Component({
  selector: 'create-modal',
  templateUrl: './create-modal.html',
  styleUrls: ['./create-modal.component.scss']
})
export class CrearPesoModal implements OnInit {

  newWeightForm: FormGroup;
  loading = false;
  showAlert = false;
  date = new Date();

  constructor(
    public dialogRef: MatDialogRef<PesosComponent>,
    private fb: FormBuilder,
    public alert: AlertNoticeService,
    private weightService: WeightService
  ) {
  }

  ngOnInit(): void {
    this.newWeightForm = this.fb.group({
      weight: [, Validators.required]
    })
  }

  onNoClick(refresh): void {
    this.dialogRef.close(refresh);
  }

  get f() {
    return this.newWeightForm.controls;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.newWeightForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  submit(form) {
    this.loading = true;
    this.showAlert = false;
    if (form.valid) {
      const data = {
        name: form.value.weight
      }
      this.weightService.createWeight(data).subscribe(_res => {
        this.alert.setNotice('Peso creado correctamente', 'success');
        this.showAlert = true;
        this.loading = false;
        setTimeout(() => this.onNoClick(true), 1000);
      }, _err => {
        this.alert.setNotice('No se pudo crear el peso', 'danger');
        this.showAlert = true;
        this.loading = false;
      })
    } else {
      this.loading = false;
    }
  }

}
